import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class NoCacheHeadersInterceptorService implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler) {
      const authReq = req.clone({
          setHeaders: {
              'Cache-Control': 'no-cache',
               Pragma: 'no-cache'
          }
      });
      return next.handle(authReq);    
  }
  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/no-cache-headers-interceptor.service.ts